module.exports = __webpack_public_path__ + "static/media/products.7535dbd5.svg";